export default __webpack_public_path__ + "dist/assets/target-pin-map.png";